__turbopack_context__.v({
  "active": "Navigation-module-scss-module__59DUwW__active",
  "item": "Navigation-module-scss-module__59DUwW__item",
  "nav": "Navigation-module-scss-module__59DUwW__nav",
  "scrollArea": "Navigation-module-scss-module__59DUwW__scrollArea",
  "shimmer": "Navigation-module-scss-module__59DUwW__shimmer",
  "skeleton": "Navigation-module-scss-module__59DUwW__skeleton",
});
